import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {getPublicProfile, submitForReview} from '../../utils/designerApi';
import {useAuth} from '../Auth/AuthContext';
import {CartProvider, FloatingCheckoutBar, useCart} from './CustomBlocks';

// Social icons configuration
const socialIcons = {
    instagram: {
        icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
        color: '#E4405F'
    },
    tiktok: {
        icon: 'M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z',
        color: '#000000'
    },
    youtube: {
        icon: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
        color: '#FF0000'
    },
    twitter: {
        icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
        color: '#000000'
    },
    facebook: {
        icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
        color: '#1877F2'
    },
    linkedin: {
        icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
        color: '#0A66C2'
    }
};

// Block renderers for public view
function renderProfileHeader(props) {
    const {name, bio, avatarUrl, layout, visibleSocials = 'instagram,tiktok'} = props;
    const isCentered = layout === 'centered';
    const visibleList = visibleSocials.split(',').filter(Boolean);

    return (
        <div style={{
            display: 'flex',
            flexDirection: isCentered ? 'column' : 'row',
            alignItems: 'center',
            gap: isCentered ? '16px' : '20px',
            padding: '24px',
            marginBottom: '16px'
        }}>
            <div style={{
                width: isCentered ? '100px' : '80px',
                height: isCentered ? '100px' : '80px',
                borderRadius: '50%',
                overflow: 'hidden',
                backgroundColor: '#f0f0f0',
                flexShrink: 0
            }}>
                {avatarUrl ? (
                    <img src={avatarUrl} alt={name} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                ) : (
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '32px',
                        color: '#999'
                    }}>
                        {name?.charAt(0)?.toUpperCase() || '?'}
                    </div>
                )}
            </div>
            <div style={{textAlign: isCentered ? 'center' : 'left'}}>
                <h1 style={{fontSize: '24px', fontWeight: 700, margin: '0 0 8px 0', color: '#1a1a1a'}}>{name}</h1>
                <p style={{fontSize: '15px', color: '#666', margin: '0 0 12px 0', lineHeight: 1.5}}>{bio}</p>
                <div style={{display: 'flex', gap: '12px', justifyContent: isCentered ? 'center' : 'flex-start'}}>
                    {visibleList.map(platform => {
                        const url = props[platform];
                        const icon = socialIcons[platform];
                        if (!url || !icon) {return null;}
                        return (
                            <a key={platform} href={url} target="_blank" rel="noopener noreferrer" style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'transform 0.2s'
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="#333">
                                    <path d={icon.icon} />
                                </svg>
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

function renderLinkButton(props) {
    const {text, url, style: buttonStyle, size} = props;
    const isSmall = size === 'small';
    const isFull = size === 'full' || !size;
    const isFilled = buttonStyle === 'filled';

    return (
        <div style={{padding: '8px 0'}}>
            <a
                href={url || '#'}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'block',
                    width: isFull ? '100%' : 'auto',
                    padding: isSmall ? '10px 16px' : '14px 28px',
                    borderRadius: '30px',
                    fontSize: isSmall ? '13px' : '15px',
                    fontWeight: 600,
                    textDecoration: 'none',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    backgroundColor: isFilled ? '#1a1a1a' : 'transparent',
                    color: isFilled ? '#fff' : '#1a1a1a',
                    border: isFilled ? 'none' : '2px solid #1a1a1a',
                    boxSizing: 'border-box'
                }}
            >
                {text || 'Button'}
            </a>
        </div>
    );
}

function renderSocialLinks(props) {
    const {layout, align} = props;
    const isRow = layout === 'row';
    const alignMap = {left: 'flex-start', center: 'center', right: 'flex-end'};

    const activeIcons = Object.entries(socialIcons)
        .filter(([platform]) => props[platform])
        .map(([platform, icon]) => ({platform, icon, url: props[platform]}));

    if (activeIcons.length === 0) {return null;}

    return (
        <div style={{
            display: 'flex',
            flexDirection: isRow ? 'row' : 'column',
            gap: isRow ? '12px' : '8px',
            justifyContent: isRow ? alignMap[align] || 'center' : 'flex-start',
            alignItems: isRow ? 'center' : (alignMap[align] || 'center'),
            padding: '12px 0'
        }}>
            {activeIcons.map(({platform, icon, url}) => (
                <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '50%',
                        backgroundColor: '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.2s, background-color 0.2s',
                        textDecoration: 'none'
                    }}
                >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="#333">
                        <path d={icon.icon} />
                    </svg>
                </a>
            ))}
        </div>
    );
}

function renderSectionTitle(props) {
    const {title, layout, align} = props;
    const isRow = layout === 'row';
    const alignMap = {left: 'left', center: 'center', right: 'right'};

    return (
        <div style={{
            textAlign: alignMap[align] || 'left',
            padding: '20px 0 12px 0'
        }}>
            <h2 style={{
                fontSize: '20px',
                fontWeight: 700,
                color: '#1a1a1a',
                margin: 0
            }}>
                {title}
            </h2>
        </div>
    );
}

function renderGallery(props) {
    const {title, items: itemsJson, columns} = props;
    let items = [];
    try {
        items = JSON.parse(itemsJson || '[]');
    } catch (e) {
        items = [];
    }
    const columnCount = parseInt(columns) || 2;

    return (
        <div style={{padding: '12px 0'}}>
            {title && (
                <h3 style={{fontSize: '18px', fontWeight: 600, margin: '0 0 16px 0', color: '#1a1a1a'}}>{title}</h3>
            )}
            <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
                gap: '16px'
            }}>
                {items.map((item, index) => (
                    <div key={item.id || index} style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                        border: '1px solid #f0f0f0'
                    }}>
                        <div style={{
                            aspectRatio: '1',
                            backgroundColor: '#f5f5f5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            {item.imageUrl ? (
                                <img src={item.imageUrl} alt={item.name} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                            ) : (
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                    <circle cx="8.5" cy="8.5" r="1.5"/>
                                    <polyline points="21,15 16,10 5,21"/>
                                </svg>
                            )}
                        </div>
                        <div style={{padding: '12px'}}>
                            <h4 style={{fontSize: '14px', fontWeight: 600, margin: '0 0 4px 0', color: '#1a1a1a'}}>
                                {item.name || 'Product'}
                            </h4>
                            {item.price && (
                                <p style={{fontSize: '14px', fontWeight: 700, margin: 0, color: '#1a1a1a'}}>
                                    {item.price}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

// ProductCard component with cart functionality
function ProductCardRenderer({props}) {
    const {productName, price, imageUrl, shopUrl, productId, brandName, brandSlug} = props;
    const {cart, addToCart, isInCart, updateQuantity} = useCart();
    const isBrandProduct = !!productId;
    const inCart = isBrandProduct && isInCart(productId, productId);

    // Get current quantity from cart
    const cartItem = cart.find(item => item.id === productId || item.productId === productId);
    const quantity = cartItem?.quantity || 0;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: '16px',
            marginBottom: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
        }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'flex-start'}}>
                <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    backgroundColor: '#f5f5f5',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {imageUrl ? (
                        <img src={imageUrl} alt={productName} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                    ) : (
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                            <circle cx="8.5" cy="8.5" r="1.5"/>
                            <polyline points="21,15 16,10 5,21"/>
                        </svg>
                    )}
                </div>
                <div style={{flex: 1}}>
                    <h3 style={{fontSize: '18px', fontWeight: 600, margin: '0 0 6px 0', color: '#1a1a1a'}}>{productName}</h3>
                    {price && <p style={{fontSize: '15px', fontWeight: 700, margin: '0 0 6px 0', color: '#1a1a1a'}}>${price}</p>}

                    {/* Brand Product - Add to Cart or Quantity Controls */}
                    {isBrandProduct ? (
                        inCart ? (
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0',
                                backgroundColor: '#10b981',
                                borderRadius: '24px',
                                overflow: 'hidden'
                            }}>
                                <button
                                    onClick={() => updateQuantity(productId, quantity - 1)}
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                        color: '#fff',
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    −
                                </button>
                                <span style={{
                                    minWidth: '32px',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#fff'
                                }}>
                                    {quantity}
                                </span>
                                <button
                                    onClick={() => updateQuantity(productId, quantity + 1)}
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                        color: '#fff',
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        ) : (
                            <button
                                onClick={() => addToCart({
                                    id: productId,
                                    productId: productId,
                                    name: productName,
                                    price: parseFloat(price) || 0,
                                    imageUrl: imageUrl,
                                    brandSlug: brandSlug || brandName
                                })}
                                style={{
                                    display: 'inline-block',
                                    padding: '10px 24px',
                                    backgroundColor: '#3b82f6',
                                    border: 'none',
                                    borderRadius: '24px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#fff',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add to Cart
                            </button>
                        )
                    ) : (
                        /* Manual/Affiliate Product - Shop Now link */
                        <a
                            href={shopUrl || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'inline-block',
                                padding: '10px 24px',
                                backgroundColor: '#fff',
                                border: '1.5px solid #1a1a1a',
                                borderRadius: '24px',
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#1a1a1a',
                                textDecoration: 'none',
                                transition: 'all 0.2s'
                            }}
                        >
                            Shop Now
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

function renderProductCard(props) {
    return <ProductCardRenderer props={props} />;
}

function renderShoppablePost(props) {
    const {title, description, imageUrl} = props;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            overflow: 'hidden',
            marginBottom: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
        }}>
            {imageUrl && (
                <div style={{aspectRatio: '16/9', backgroundColor: '#f5f5f5'}}>
                    <img src={imageUrl} alt={title} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                </div>
            )}
            <div style={{padding: '16px'}}>
                <h3 style={{fontSize: '18px', fontWeight: 600, margin: '0 0 8px 0', color: '#1a1a1a'}}>{title}</h3>
                <p style={{fontSize: '14px', color: '#666', margin: 0, lineHeight: 1.5}}>{description}</p>
            </div>
        </div>
    );
}

function renderShoppableVideo(props) {
    const {title, videoUrl, thumbnailUrl} = props;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            overflow: 'hidden',
            marginBottom: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
        }}>
            <div style={{
                aspectRatio: '16/9',
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {videoUrl ? (
                    // Render actual video player if video URL exists
                    <video
                        src={videoUrl}
                        controls
                        playsInline
                        poster={thumbnailUrl || ''}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                ) : thumbnailUrl ? (
                    // Show thumbnail with play button overlay if only thumbnail exists
                    <>
                        <img src={thumbnailUrl} alt={title} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                        <div style={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0,0,0,0.3)'
                        }}>
                            <div style={{
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(255,255,255,0.9)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="#1a1a1a">
                                    <path d="M8 5v14l11-7z"/>
                                </svg>
                            </div>
                        </div>
                    </>
                ) : (
                    // Show placeholder if no video or thumbnail
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#666'
                    }}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
                            <line x1="7" y1="2" x2="7" y2="22"/>
                            <line x1="17" y1="2" x2="17" y2="22"/>
                            <line x1="2" y1="12" x2="22" y2="12"/>
                            <line x1="2" y1="7" x2="7" y2="7"/>
                            <line x1="2" y1="17" x2="7" y2="17"/>
                            <line x1="17" y1="17" x2="22" y2="17"/>
                            <line x1="17" y1="7" x2="22" y2="7"/>
                        </svg>
                        <span style={{fontSize: '12px', marginTop: '8px'}}>No video</span>
                    </div>
                )}
            </div>
            {title && (
                <div style={{padding: '16px'}}>
                    <h3 style={{fontSize: '16px', fontWeight: 600, margin: 0, color: '#1a1a1a'}}>{title}</h3>
                </div>
            )}
        </div>
    );
}

// ProductGallery component with cart functionality
function ProductGalleryRenderer({props}) {
    const {title, items: itemsJson, buttonStyle, layout} = props;
    const {cart, addToCart, isInCart, updateQuantity} = useCart();

    // Parse items from JSON string
    let items = [];
    try {
        items = JSON.parse(itemsJson || '[]');
    } catch (e) {
        items = [];
    }

    if (items.length === 0) {
        return null;
    }

    const isFilled = buttonStyle === 'filled';
    const isGrid = layout === 'grid';
    const isBrandProduct = (item) => !!item.productId;

    // Helper to get quantity for an item
    const getQuantity = (item) => {
        const cartItem = cart.find(c => c.id === item.productId || c.productId === item.productId);
        return cartItem?.quantity || 0;
    };

    // Container styles based on layout
    const containerStyle = isGrid ? {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px'
    } : {
        display: 'flex',
        gap: '12px',
        overflowX: 'auto',
        paddingBottom: '8px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    // Card styles based on layout
    const cardStyle = isGrid ? {
        backgroundColor: '#fff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    } : {
        flex: '0 0 160px',
        width: '160px',
        backgroundColor: '#fff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    };

    return (
        <div style={{marginBottom: '20px'}}>
            {title && (
                <h3 style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#1a1a1a',
                    margin: '0 0 12px 0'
                }}>
                    {title}
                </h3>
            )}
            <div style={containerStyle}>
                {items.map((item, index) => {
                    const inCart = isBrandProduct(item) && isInCart(item.productId, item.productId);
                    const quantity = getQuantity(item);

                    return (
                        <div key={item.id || index} style={cardStyle}>
                            {/* Product Image */}
                            <div style={{
                                width: '100%',
                                height: '140px',
                                backgroundColor: '#f5f5f5',
                                overflow: 'hidden'
                            }}>
                                {item.imageUrl ? (
                                    <img
                                        src={item.imageUrl}
                                        alt={item.name}
                                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                    />
                                ) : (
                                    <div style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
                                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                            <circle cx="8.5" cy="8.5" r="1.5"/>
                                            <polyline points="21,15 16,10 5,21"/>
                                        </svg>
                                    </div>
                                )}
                            </div>

                            {/* Product Info */}
                            <div style={{padding: '12px'}}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#1a1a1a',
                                    marginBottom: '4px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {item.name || 'Product'}
                                </div>
                                <div style={{
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#1a1a1a',
                                    marginBottom: '10px'
                                }}>
                                    ${item.price || '0.00'}
                                </div>

                                {/* Brand Product - Add to Cart or Quantity Controls */}
                                {isBrandProduct(item) ? (
                                    inCart ? (
                                        <div style={{
                                            display: 'flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '0',
                                            backgroundColor: '#10b981',
                                            borderRadius: '24px',
                                            overflow: 'hidden',
                                            boxSizing: 'border-box'
                                        }}>
                                            <button
                                                onClick={() => updateQuantity(item.productId, quantity - 1)}
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    border: 'none',
                                                    backgroundColor: 'transparent',
                                                    color: '#fff',
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                −
                                            </button>
                                            <span style={{
                                                minWidth: '24px',
                                                textAlign: 'center',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                color: '#fff'
                                            }}>
                                                {quantity}
                                            </span>
                                            <button
                                                onClick={() => updateQuantity(item.productId, quantity + 1)}
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    border: 'none',
                                                    backgroundColor: 'transparent',
                                                    color: '#fff',
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={() => addToCart({
                                                id: item.productId,
                                                productId: item.productId,
                                                name: item.name,
                                                price: parseFloat(item.price) || 0,
                                                imageUrl: item.imageUrl,
                                                brandSlug: item.brandSlug || item.brandName
                                            })}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                padding: '10px 12px',
                                                borderRadius: '24px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                textAlign: 'center',
                                                boxSizing: 'border-box',
                                                backgroundColor: isFilled ? '#3b82f6' : 'transparent',
                                                color: isFilled ? '#fff' : '#3b82f6',
                                                border: isFilled ? 'none' : '2px solid #3b82f6',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Add to Cart
                                        </button>
                                    )
                                ) : (
                                    /* Affiliate/Manual Product - Link button */
                                    <a
                                        href={item.buttonUrl || '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            padding: '10px 12px',
                                            borderRadius: '24px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            textAlign: 'center',
                                            textDecoration: 'none',
                                            boxSizing: 'border-box',
                                            backgroundColor: isFilled ? '#ff6b6b' : 'transparent',
                                            color: isFilled ? '#fff' : '#ff6b6b',
                                            border: isFilled ? 'none' : '2px solid #ff6b6b'
                                        }}
                                    >
                                        {item.buttonText || 'Shop Now'}
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function renderProductGallery(props) {
    return <ProductGalleryRenderer props={props} />;
}

function renderAskAI(props) {
    const {aiName, questionPlaceholder} = props;

    return (
        <div style={{
            backgroundColor: '#fff',
            border: '1px solid #e5e5e5',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '16px'
        }}>
            <div style={{fontSize: '14px', fontWeight: 500, color: '#1a1a1a', marginBottom: '8px'}}>
                Ask {aiName}:
            </div>
            <div style={{display: 'flex', gap: '8px'}}>
                <input
                    type="text"
                    placeholder={questionPlaceholder}
                    style={{
                        flex: 1,
                        padding: '10px 14px',
                        border: '1px solid #e5e5e5',
                        borderRadius: '8px',
                        fontSize: '14px',
                        outline: 'none',
                        backgroundColor: '#fafafa'
                    }}
                />
                <button style={{
                    padding: '10px 20px',
                    backgroundColor: '#1a1a1a',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 500,
                    cursor: 'pointer'
                }}>
                    Ask
                </button>
            </div>
        </div>
    );
}

// Render a paragraph block (default BlockNote block)
function renderParagraph(block) {
    if (!block.content || block.content.length === 0) {
        return null;
    }

    const text = block.content.map(item => {
        if (item.type === 'text') {
            return item.text;
        }
        if (item.type === 'link') {
            return item.content?.map(c => c.text).join('') || '';
        }
        return '';
    }).join('');

    if (!text.trim()) {return null;}

    return (
        <p style={{fontSize: '15px', color: '#333', margin: '0 0 12px 0', lineHeight: 1.6}}>
            {text}
        </p>
    );
}

// Render a heading block
function renderHeading(block) {
    const text = block.content?.map(item => item.text || '').join('') || '';
    const level = block.props?.level || 1;
    const sizes = {1: '28px', 2: '24px', 3: '20px'};

    return (
        <div style={{fontSize: sizes[level] || '24px', fontWeight: 700, margin: '0 0 16px 0', color: '#1a1a1a'}}>
            {text}
        </div>
    );
}

// Main block renderer
function renderBlock(block) {
    switch (block.type) {
    case 'profileHeader':
        return renderProfileHeader(block.props);
    case 'linkButton':
        return renderLinkButton(block.props);
    case 'socialLinks':
        return renderSocialLinks(block.props);
    case 'sectionTitle':
        return renderSectionTitle(block.props);
    case 'gallery':
        return renderGallery(block.props);
    case 'productCard':
        return renderProductCard(block.props);
    case 'shoppablePost':
        return renderShoppablePost(block.props);
    case 'shoppableVideo':
        return renderShoppableVideo(block.props);
    case 'productGallery':
        return renderProductGallery(block.props);
    case 'askAI':
        return renderAskAI(block.props);
    case 'paragraph':
        return renderParagraph(block);
    case 'heading':
        return renderHeading(block);
    default:
        return null;
    }
}

export default function BlockNotePublicProfile() {
    const params = useParams();
    const {tokens, isLoading: authLoading} = useAuth();
    const [profileData, setProfileData] = useState(null);
    const [publicProfileId, setPublicProfileId] = useState(null); // profile id for checkout (order source)
    const [ownerNotice, setOwnerNotice] = useState(null); // alert for owner viewing unpublished
    const [ownerProfile, setOwnerProfile] = useState(null); // full profile data for owner actions
    const [comingSoon, setComingSoon] = useState(false); // non-owner viewing unpublished
    const [submitting, setSubmitting] = useState(false); // submit for review loading state
    const [error, setError] = useState(null);

    useEffect(() => {
        document.body.classList.add('public-profile-active');

        return () => {
            document.body.classList.remove('public-profile-active');
            document.body.style.backgroundColor = '';
        };
    }, []);

    // Update body background when profile data loads
    useEffect(() => {
        if (profileData?.settings?.backgroundColor) {
            document.body.style.backgroundColor = profileData.settings.backgroundColor;
        }
    }, [profileData]);

    // Fetch profile from backend API (mydomain/profile-slug)
    // Backend handles owner detection via optional Bearer token:
    //   - Published profiles → visible to everyone
    //   - Unpublished profiles → visible only to the authenticated owner (draft preview)
    // Wait for auth to finish loading before making the call so the token is available.
    useEffect(() => {
        if (authLoading) return; // wait for auth state to load from localStorage

        if (!params.slug) {
            setError('Invalid profile link. Expected format: /profile-slug');
            return;
        }

        // Reset states on each fetch (e.g. when token changes)
        setProfileData(null);
        setPublicProfileId(null);
        setOwnerNotice(null);
        setOwnerProfile(null);
        setComingSoon(false);
        setError(null);

        (async () => {
            const result = await getPublicProfile({
                slug: params.slug,
                accessToken: tokens?.accessToken || undefined
            });

            if (result.ok && result.data?.profile) {
                const prof = result.data.profile;
                setProfileData({
                    settings: prof.settingsJson || {},
                    editorContent: prof.editorState?.document || prof.editorState || []
                });
                if (prof.profileId != null) setPublicProfileId(prof.profileId);

                // If owner viewing their own profile, show status-based notice
                if (prof.isOwner) {
                    setOwnerProfile({
                        id: prof.profileId,
                        status: prof.status || 'draft',
                        slug: prof.slug
                    });

                    const status = prof.status || 'draft';
                    if (status === 'pending_review') {
                        setOwnerNotice('Your profile has been submitted and is currently under review. You will be notified once it is approved.');
                    } else if (status === 'rejected') {
                        setOwnerNotice('Your profile submission was not approved. Please make changes and submit again for review.');
                    } else if (status === 'published') {
                        // Published profile - no notice needed
                    } else {
                        // draft or any other status
                        setOwnerNotice('This is a preview of your profile. It is not publicly visible yet. Submit it for review to get it published.');
                    }
                }
                return;
            }

            // Profile not found for this user → show Coming Soon for non-owners
            setComingSoon(true);
        })();
    }, [params.slug, tokens?.accessToken, authLoading]);

    // Coming Soon page for non-owners
    if (comingSoon) {
        return (
            <div style={styles.comingSoonContainer}>
                <div style={styles.comingSoonCard}>
                    <div style={styles.comingSoonIcon}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1.5">
                            <circle cx="12" cy="12" r="10"/>
                            <polyline points="12 6 12 12 16 14"/>
                        </svg>
                    </div>
                    <h1 style={styles.comingSoonTitle}>Coming Soon</h1>
                    <p style={styles.comingSoonText}>This profile is being set up and will be available shortly.</p>
                    <p style={styles.comingSoonSubtext}>Check back later!</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.errorContainer}>
                <div style={styles.errorCard}>
                    <h1 style={styles.errorTitle}>Profile Not Found</h1>
                    <p style={styles.errorText}>{error}</p>
                    <p style={styles.errorSubtext}>The profile link may be invalid or expired.</p>
                </div>
            </div>
        );
    }

    if (!profileData) {
        return (
            <div style={styles.loading}>
                <p>Loading profile...</p>
            </div>
        );
    }

    const {editorContent, settings} = profileData;
    const backgroundColor = settings?.backgroundColor || '#f8f8f8';
    const isDark = ['#1a1a2e', '#2d3436', '#0d0d0d', '#1e272e'].includes(backgroundColor);

    return (
        <CartProvider profileId={publicProfileId ?? undefined}>
            <div style={{...styles.pageContainer, backgroundColor}}>
                {/* Owner notice banner for unpublished profiles */}
                {ownerNotice && ownerProfile && (() => {
                    const status = ownerProfile.status || 'draft';
                    const isPending = status === 'pending_review';
                    const isRejected = status === 'rejected';
                    const bannerStyle = isPending
                        ? styles.ownerNoticeBannerInfo
                        : isRejected
                            ? styles.ownerNoticeBannerDanger
                            : styles.ownerNoticeBanner;
                    const contentStyle = isPending
                        ? styles.ownerNoticeContentInfo
                        : isRejected
                            ? styles.ownerNoticeContentDanger
                            : styles.ownerNoticeContent;
                    const iconColor = isPending ? '#0c5460' : isRejected ? '#721c24' : '#856404';
                    const canSubmit = !isPending; // can submit if draft or rejected

                    return (
                        <div style={bannerStyle}>
                            <div style={contentStyle}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2" style={{flexShrink: 0}}>
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="12" y1="8" x2="12" y2="12"/>
                                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                                </svg>
                                <span style={{flex: 1}}>{ownerNotice}</span>
                                {canSubmit && (
                                    <button
                                        style={{
                                            ...styles.submitButton,
                                            ...(submitting ? styles.submitButtonDisabled : {})
                                        }}
                                        disabled={submitting}
                                        onClick={async () => {
                                            setSubmitting(true);
                                            const result = await submitForReview({
                                                accessToken: tokens?.accessToken,
                                                id: ownerProfile.id
                                            });
                                            if (result.ok) {
                                                setOwnerProfile(prev => ({...prev, status: 'pending_review'}));
                                                setOwnerNotice('Your profile has been submitted and is currently under review. You will be notified once it is approved.');
                                            } else {
                                                alert(result.error || 'Failed to submit for review. Please try again.');
                                            }
                                            setSubmitting(false);
                                        }}
                                    >
                                        {submitting ? 'Submitting...' : 'Submit for Review'}
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })()}

                <div style={styles.contentContainer}>
                    {editorContent && Array.isArray(editorContent) && editorContent.map((block, index) => (
                        <div key={block.id || index}>
                            {renderBlock(block)}
                        </div>
                    ))}
                </div>

                <div style={styles.footer}>
                    <a href="/login" style={styles.footerLink}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M13.8 12H3"/>
                        </svg>
                        Log In
                    </a>
                </div>

                {/* Floating Cart Checkout Bar */}
                <FloatingCheckoutBar />
            </div>
        </CartProvider>
    );
}

const styles = {
    pageContainer: {
        minHeight: '100vh',
        backgroundColor: '#f8f8f8',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    contentContainer: {
        maxWidth: '600px',
        margin: '0 auto',
        padding: '40px 20px',
        paddingBottom: '100px'
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontSize: '16px',
        color: '#666',
        backgroundColor: '#f8f8f8'
    },
    errorContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f8f8',
        padding: '20px'
    },
    errorCard: {
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '40px',
        textAlign: 'center',
        maxWidth: '400px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    },
    errorTitle: {
        fontSize: '24px',
        fontWeight: '600',
        color: '#1a1a1a',
        margin: '0 0 12px 0'
    },
    errorText: {
        fontSize: '16px',
        color: '#666',
        margin: '0 0 8px 0'
    },
    errorSubtext: {
        fontSize: '14px',
        color: '#999',
        margin: 0
    },
    footer: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '12px 20px',
        backgroundColor: '#fff',
        borderTop: '1px solid #eee',
        display: 'flex',
        justifyContent: 'center'
    },
    footerLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#666',
        textDecoration: 'none',
        fontSize: '14px'
    },
    // Owner notice banner - draft (yellow/warning)
    ownerNoticeBanner: {
        backgroundColor: '#fff3cd',
        borderBottom: '1px solid #ffc107',
        padding: '12px 20px'
    },
    ownerNoticeContent: {
        maxWidth: '600px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
        color: '#856404',
        lineHeight: '1.5'
    },
    // Owner notice banner - pending review (blue/info)
    ownerNoticeBannerInfo: {
        backgroundColor: '#d1ecf1',
        borderBottom: '1px solid #bee5eb',
        padding: '12px 20px'
    },
    ownerNoticeContentInfo: {
        maxWidth: '600px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
        color: '#0c5460',
        lineHeight: '1.5'
    },
    // Owner notice banner - rejected (red/danger)
    ownerNoticeBannerDanger: {
        backgroundColor: '#f8d7da',
        borderBottom: '1px solid #f5c6cb',
        padding: '12px 20px'
    },
    ownerNoticeContentDanger: {
        maxWidth: '600px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
        color: '#721c24',
        lineHeight: '1.5'
    },
    // Submit for review button
    submitButton: {
        flexShrink: 0,
        padding: '8px 18px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: '600',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'background-color 0.2s'
    },
    submitButtonDisabled: {
        backgroundColor: '#6c757d',
        cursor: 'not-allowed',
        opacity: 0.7
    },
    // Coming Soon page
    comingSoonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f8f8',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    comingSoonCard: {
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: '420px',
        width: '100%',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    },
    comingSoonIcon: {
        marginBottom: '20px'
    },
    comingSoonTitle: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1a1a1a',
        margin: '0 0 12px 0'
    },
    comingSoonText: {
        fontSize: '16px',
        color: '#666',
        margin: '0 0 8px 0',
        lineHeight: '1.5'
    },
    comingSoonSubtext: {
        fontSize: '14px',
        color: '#999',
        margin: 0
    }
};

export {BlockNotePublicProfile};
